import { useNavigate } from 'react-router-dom'
import { IProject } from 'screens/Projects/projects.types'
import Card from 'shared/Cards/Card'

type IProps = {
  projects: IProject[]
}

const UserProjectsCard = (props: IProps) => {
  const navigate = useNavigate()

  return (
    <Card type='normal'>
      <div className='flex-lines'>
        <div style={{ marginBottom: '16px' }}>
          <h2 className='text--caption-l text-700'>Архив проектов</h2>
        </div>
        {props.projects.length > 0 ? (
          props.projects.map((p) => (
            <span
              style={{ width: 'fit-content' }}
              key={p.id}
              className='text--body-m text--link text--link-underline'
              onClick={() => navigate('/projects/' + p.id)}
            >
              {p.name}
            </span>
          ))
        ) : (
          <div className='flex-lines text--body-m' style={{ gap: '6px' }}>
            <p>Тут пока ничего нет 😞</p>
            <p>Все будет, главное не сдаваться! 🚀</p>
          </div>
        )}
      </div>
    </Card>
  )
}

export default UserProjectsCard
